import auth from '../../services/auth'

export default {

  data() {
    return {
      taxIdNumber: undefined,
      loading: false,
      chooseEmail: false,
      chooseCellphone: false,
      email: undefined,
      cellphone: undefined,
      channelSelected: undefined,
      origemTelas: undefined,
      errorMessage: undefined
    }
  },

  watch: {
    channelSelectedForm(newValue) {
      if (this.channelSelected == 'EMAIL') {
        this.chooseEmail = true;
      } else 
      if (this.channelSelected == 'SMS') {
        this.chooseCellphone = true;
      }
    },
  },

  computed: {
    type() {
      return this.$route.params.type;
    }
  },

  created(){
    //this.taxIdNumber = this.$route.query.taxIdNumber;
   // this.origemTelas = this.$route.params.type;
  },

  methods: {
    validate() {
      if(this.chooseEmail) {
        this.showCellphoneForm = false;
        this.showEmailForm = true;
      }
      if(this.chooseCellphone) {
        this.showCellphoneForm = true;
        this.showEmailForm = false;
      }
    },
    
    doRequest() {
      this.errorMessage = undefined;

      auth.tokenGenerateResend(auth.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase(), 'LOGIN', this.channelSelected).then(res => {
        this.$router.push({name: '2fa-login', params: {type: this.channelSelected}});
      }).catch(err => {
        this.errorMessage = err.data.status.message;
      });

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/choose-channel-interno.js